import * as React from 'react'

const EyeOpen = (props: any) => {
  return (
    <svg {...props} width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clipeyeopen0)'>
        <path
          d='M6.99995 7.49219C5.64301 7.49219 4.53906 8.59616 4.53906 9.95312C4.53906 11.3101 5.64301 12.4141 6.99995 12.4141C8.35689 12.4141 9.46084 11.3101 9.46084 9.95312C9.46084 8.59616 8.35689 7.49219 6.99995 7.49219ZM6.99995 11.3203C6.24608 11.3203 5.63279 10.707 5.63279 9.95312C5.63279 9.19926 6.24608 8.58594 6.99995 8.58594C7.75382 8.58594 8.36711 9.19926 8.36711 9.95312C8.36711 10.707 7.75382 11.3203 6.99995 11.3203Z'
          fill='black'
        />
        <path
          d='M13.9412 8.65774C13.338 7.46312 12.3822 6.4511 11.1764 5.72975L12.6567 4.24941C12.8703 4.03586 12.8703 3.6896 12.6567 3.47602C12.4431 3.26246 12.0969 3.26246 11.8833 3.47602L10.1467 5.2127C9.32817 4.87394 8.44962 4.67018 7.54686 4.61152V2.13281C7.54686 1.83077 7.30203 1.58594 6.99999 1.58594C6.69795 1.58594 6.45311 1.83077 6.45311 2.13281V4.6115C5.55036 4.67015 4.6718 4.87391 3.8533 5.21268L2.11667 3.47599C1.90309 3.26241 1.5568 3.26241 1.34325 3.47599C1.12972 3.68955 1.12972 4.0358 1.34328 4.24938L2.82359 5.72972C1.61778 6.45107 0.661952 7.46309 0.0588038 8.65771C-0.0773134 8.92735 0.0309132 9.25624 0.300523 9.39239C0.57005 9.52853 0.899077 9.42033 1.03517 9.15069C2.04957 7.14156 4.31018 5.6875 7.00002 5.6875C9.69187 5.6875 11.9513 7.14331 12.9648 9.15072C13.1012 9.4208 13.4303 9.52834 13.6995 9.39241C13.9691 9.25627 14.0773 8.92735 13.9412 8.65774Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clipeyeopen0'>
          <rect width='14' height='14' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default EyeOpen



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/EyeOpen.tsx